import React from 'react'

export const StudentLeaderboardConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/student-settings/leaderboard',
            component: React.lazy(() => import('./StudentLeaderboard')),
            applicationPath: 'StudentLeaderboard',
        },
    ]
}